{
  "title": "Rapports Programmés",
  "subtitle": "Configurez des rapports automatiques par e-mail pour votre FBO",
  "status": {
    "notConfigured": "Non Configuré",
    "disabled": "Désactivé",
    "enabled": "Activé"
  },
  "lastRun": {
    "never": "Jamais",
    "justNow": "À l'instant",
    "minutesAgo": "Il y a {{count}} min",
    "hoursAgo": "Il y a {{count}} h"
  },
  "occupancy": {
    "title": "Rapport d'Occupation Nocturne",
    "subtitle": "Instantané quotidien des aéronefs",
    "description": "Envoie automatiquement un instantané de tous les aéronefs dans les hangars et les aires de stationnement à une heure programmée chaque nuit."
  },
  "labels": {
    "locations": "Emplacements",
    "hangars": "hangars",
    "ramps": "aires de stationnement",
    "selected": "sélectionnés",
    "snapshotTime": "Heure du Rapport",
    "recipients": "Destinataires",
    "emailsConfigured": "e-mail(s) configuré(s)",
    "lastRun": "Dernière Exécution",
    "nextRun": "Prochaine Exécution",
    "error": "Erreur :"
  },
  "buttons": {
    "configure": "Configurer",
    "setUp": "Configurer le Rapport",
    "disable": "Désactiver"
  },
  "disableDialog": {
    "title": "Désactiver le Rapport",
    "message": "Êtes-vous sûr de vouloir désactiver ce rapport programmé ? Vous pourrez le réactiver ultérieurement.",
    "confirm": "Désactiver le Rapport"
  },
  "configDialog": {
    "titleNew": "Configurer le Rapport d'Occupation",
    "titleEdit": "Configurer le Rapport d'Occupation",
    "testEmailSent": "E-mail de test envoyé ! Vérifiez votre boîte de réception.",
    "fields": {
      "enableReport": "Activer le rapport programmé",
      "hangars": "Hangars",
      "selectHangars": "Sélectionner les hangars...",
      "hangarsHelp": "Sélectionnez les hangars à inclure dans le rapport",
      "ramps": "Aires de Stationnement",
      "selectRamps": "Sélectionner les aires...",
      "rampsHelp": "Sélectionnez les aires de stationnement à inclure dans le rapport",
      "noRampsAvailable": "Aucune aire de stationnement disponible",
      "snapshotTime": "Heure du Rapport",
      "snapshotTimeHelp": "Quand capturer et envoyer le rapport",
      "recipients": "Destinataires",
      "recipientsHelp": "Liste d'adresses e-mail séparées par des virgules",
      "fileFormat": "Format de la Pièce Jointe",
      "fileFormatHelp": "Le CSV s'ouvre directement dans Excel. Le TSV utilise des valeurs séparées par tabulation.",
      "timezone": "Fuseau Horaire"
    },
    "buttons": {
      "sendTest": "Envoyer un E-mail de Test"
    },
    "errors": {
      "noLocationsSelected": "Veuillez sélectionner au moins un hangar ou une aire de stationnement",
      "noRecipients": "Veuillez entrer au moins une adresse e-mail",
      "invalidEmails": "Adresse(s) e-mail invalide(s) : {{emails}}",
      "noSnapshotTime": "Veuillez définir une heure du rapport",
      "saveFailed": "Échec de l'enregistrement de la configuration. Veuillez réessayer.",
      "testFailed": "Échec de l'envoi de l'e-mail de test. Veuillez réessayer."
    }
  }
}
